import { Loader2 } from "lucide-react";
import { SettingsCard } from "../../ui";

export default function LoadingCard() {
  return (
    <SettingsCard>
      <div role="status" className="flex justify-center py-4 text-gray-500">
        <Loader2 className="size-5 animate-spin" aria-hidden="true" />
      </div>
    </SettingsCard>
  );
}
